/**
 * 访问公司列表短缓存（sessionStorage），减轻首页等待与重复请求。
 */
import { getWorkflowHostCompanies } from '../api/api'

const STORAGE_KEY = 'visitor_workflow_host_companies_v1'
const TTL_MS = 8 * 60 * 1000

function parseEntry () {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const o = JSON.parse(raw)
    if (!o || !Array.isArray(o.list) || typeof o.ts !== 'number') return null
    return o
  } catch (e) {
    return null
  }
}

export function readWorkflowHostCompaniesCache () {
  const o = parseEntry()
  if (!o) return null
  if (Date.now() - o.ts > TTL_MS) return null
  return o.list
}

export function writeWorkflowHostCompaniesCache (list) {
  try {
    if (!Array.isArray(list)) return
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ list, ts: Date.now() }))
  } catch (e) {}
}

export function isWorkflowHostCompaniesCacheFresh () {
  const o = parseEntry()
  if (!o) return false
  return Date.now() - o.ts <= TTL_MS
}

/**
 * 缓存未过期时跳过；用于 App 启动后台预热。
 */
export function prefetchWorkflowHostCompaniesInBackground () {
  if (isWorkflowHostCompaniesCacheFresh()) {
    return
  }
  getWorkflowHostCompanies()
    .then((list) => {
      if (Array.isArray(list)) {
        writeWorkflowHostCompaniesCache(list)
      }
    })
    .catch(() => {})
}
